import cytoscape from 'cytoscape';

export const cytoscapeStyle: cytoscape.StylesheetJson = [
  {
    selector: 'node',
    style: {
      'font-family': 'AbyssEnterpriseSansVF, Arial, sans-serif',
      label: 'data(value)',
      width: '16px',
      height: '16px',
      'text-margin-y': -4,
      'text-valign': 'top',
      'text-halign': 'center',
      'text-outline-color': '#ffffff',
      'text-outline-width': 1,
      'text-outline-opacity': 1,
      'border-width': 3,
      'border-opacity': 1,
      color: '#000000',
    },
  },
  {
    selector: 'edge',
    style: {
      width: 1.5,
      'line-color': '#DFF5F9',
      'line-style': 'solid',
      'target-arrow-shape': 'none',
      'curve-style': 'bezier',
      'source-endpoint': 'outside-to-node',
      'target-endpoint': 'outside-to-node',
    },
  },
  {
    selector: 'node, edge',
    style: {
      opacity: 1,
      'transition-property': 'opacity',
      // @ts-ignore
      'transition-duration': '0.2s',
      'transition-timing-function': 'ease-in-out',
    },
  },
  {
    selector: 'node:active, edge:active',
    style: {
      'overlay-opacity': 0,
      'underlay-color': '#DFF5F9',
      'underlay-opacity': 0.8,
    },
  },
  {
    selector: '.fade',
    style: {
      opacity: 0.15,
    },
  },
];
